/* GRWN. – universelle Varianten-Sichtbarkeit für Pebble Custom Sections. */
(() => {
  'use strict';
  const SIZE_NAMES = /^(größe|groesse|grösse|size)$/i;
  const valid = new Set(['S', 'M', 'XL']);
  const normalize = (value) => String(value ?? '').trim().toUpperCase();

  function sizeFromPicker() {
    const picker = document.querySelector('#MainContent variant-picker, main variant-picker');
    if (!picker) return null;
    // Native controls: fieldset legend, select label, or Pebble data-option-name.
    const groups = picker.querySelectorAll('fieldset, [data-option-name], select');
    for (const group of groups) {
      const name = (group.getAttribute('data-option-name') ||
        group.querySelector('legend')?.textContent ||
        group.getAttribute('aria-label') ||
        group.getAttribute('name') || '').replace(/:\s*.*$/, '').trim();
      if (!SIZE_NAMES.test(name)) continue;
      const input = group.matches('select') ? group : group.querySelector('input:checked, select');
      const size = normalize(input?.value);
      if (valid.has(size)) return size;
    }
    // Pebble may render option groups as labels without fieldsets.
    for (const el of picker.querySelectorAll('input:checked')) {
      const name = el.getAttribute('name') || el.closest('[data-option-name]')?.getAttribute('data-option-name') || '';
      if (SIZE_NAMES.test(name) && valid.has(normalize(el.value))) return normalize(el.value);
    }
    return null;
  }

  let currentSize = null;
  function apply() {
    const size = sizeFromPicker() || currentSize;
    for (const marker of document.querySelectorAll('[data-grwn-visibility]')) {
      const section = marker.closest('.shopify-section') || marker;
      const rule = marker.dataset.grwnVisibility;
      // Fail open: unknown size must not silently hide content.
      const visible = !valid.has(size) || rule === 'always' ||
        (rule === 'kids' && size !== 'XL') || (rule === 'up' && size === 'XL');
      section.style.setProperty('display', visible ? '' : 'none', 'important');
      if (visible) section.style.removeProperty('display');
    }
  }

  function update() {
    const detected = sizeFromPicker();
    if (detected) currentSize = detected;
    apply();
  }
  const schedule = () => requestAnimationFrame(update);
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('variant-picker')) setTimeout(update, 0);
  }, true);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  // Pebble emits a variantChanged event after its own variant update.
  document.addEventListener('variant:changed', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();
